import { render, staticRenderFns } from "./AccessTable.vue?vue&type=template&id=0c23113a&"
import script from "./AccessTable.vue?vue&type=script&lang=js&"
export * from "./AccessTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports